import { federalReviewActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [federalReviewActions.loadSuccess]: (state, action) => {
        return action.payload.entities.federalReviewMsgDetails;
    },
    [federalReviewActions.replySuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if( x.mgmxno === action.payload ) {
                delete state[x.nono];
            }
        })
    },
    [federalReviewActions.closeNotificationSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if( x.mgmxno === action.payload.mxno ) {
                delete state[x.mgno];
            }
        })
    },

})


